module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c7ffd288176b935f835311512a224d4b.svg";